module.exports = __webpack_public_path__ + "img/links-awakening.fb280a6a.jpg";